import { initialCommonState } from 'redux/initialState';

import commonActionTypes from './action-types';

const commonReducer = (state = initialCommonState, { type, payload }) => {
  switch (type) {
    case commonActionTypes.SET_CONTEXT:
      return {
        ...state,
        context: payload,
      };
    case commonActionTypes.SET_SUB_CONTEXT:
      return {
        ...state,
        subContext: payload,
      };
    default:
      return state;
  }
};

export default commonReducer;
